import {useContext } from "react"
import React from 'react'

import AuthContext from "../context/AuthContext";
import LoginPage from "../pages/auth/LoginPage";
import Header from "../components/Header";



export const Auth = (props) => {

  let {user} = useContext(AuthContext);
  return (
    (user.phone_no)? <><Header />{props.component}</> : <LoginPage/>
  )
}

export default Auth;
